import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appCountryCode]',
})
export class CountryCodeDirective {
  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    let value = this._el.nativeElement.value;

    value = value.replace(/[^\d]/g, '');

    if (value) {
      value = '+' + value;
    }

    this._el.nativeElement.value = value;
    // if (initalValue !== this._el.nativeElement.value) {
    //   event.stopPropagation();
    // }
  }
}
